import { NotifyPartyValue } from "pages/shipper/RequestFormV2/defaults/notifyPartyDefaults";
import type { SharedAddressFieldPaths, SharedContactFieldPaths } from "./sharedAddressFieldPaths";

export const NOTIFY_PARTY_PREFIX = "schedule.notify_party" as const;

export type NotifyPartyField = keyof NotifyPartyValue;

export function getNotifyPartyFieldPath(field: NotifyPartyField): `${typeof NOTIFY_PARTY_PREFIX}.${NotifyPartyField}` {
  return `${NOTIFY_PARTY_PREFIX}.${field}`;
}

export const notifyPartyFieldPaths = {
  address_type: getNotifyPartyFieldPath("address_type"),
  same_as_address_contact: getNotifyPartyFieldPath("same_as_address_contact"),
  form_address_contact_type: getNotifyPartyFieldPath("form_address_contact_type"),
  address_reference_number: getNotifyPartyFieldPath("address_reference_number"),
  address_id: getNotifyPartyFieldPath("address_id"),
  address_name: getNotifyPartyFieldPath("address_name"),
  address_street: getNotifyPartyFieldPath("address_street"),
  address_street_line2: getNotifyPartyFieldPath("address_street_line2"),
  address_city: getNotifyPartyFieldPath("address_city"),
  address_state: getNotifyPartyFieldPath("address_state"),
  address_country: getNotifyPartyFieldPath("address_country"),
  address_zipcode: getNotifyPartyFieldPath("address_zipcode"),
  airport: getNotifyPartyFieldPath("airport"),
  airport_name: getNotifyPartyFieldPath("airport_name"),
  seaport: getNotifyPartyFieldPath("seaport"),
  seaport_name: getNotifyPartyFieldPath("seaport_name"),
  contact_name: getNotifyPartyFieldPath("contact_name"),
  contact_phone: getNotifyPartyFieldPath("contact_phone"),
  contact_email: getNotifyPartyFieldPath("contact_email"),
} as const;

export function getNotifyPartySharedAddressFieldPaths(): SharedAddressFieldPaths {
  return {
    address_type: notifyPartyFieldPaths.address_type,
    address_id: notifyPartyFieldPaths.address_id,
    address_name: notifyPartyFieldPaths.address_name,
    address_reference_number: notifyPartyFieldPaths.address_reference_number,
    address_street: notifyPartyFieldPaths.address_street,
    address_street_line2: notifyPartyFieldPaths.address_street_line2,
    address_city: notifyPartyFieldPaths.address_city,
    address_state: notifyPartyFieldPaths.address_state,
    address_country: notifyPartyFieldPaths.address_country,
    address_zipcode: notifyPartyFieldPaths.address_zipcode,
    airport_name: notifyPartyFieldPaths.airport_name,
    airport_code: notifyPartyFieldPaths.airport,
    seaport_name: notifyPartyFieldPaths.seaport_name,
    seaport_code: notifyPartyFieldPaths.seaport,
  };
}

export function getNotifyPartySharedContactFieldPaths(): SharedContactFieldPaths {
  return {
    contact_name: notifyPartyFieldPaths.contact_name,
    contact_phone: notifyPartyFieldPaths.contact_phone,
    contact_email: notifyPartyFieldPaths.contact_email,
  };
}
